/* eslint-disable semi */
// 数据接口域名
import _axios from 'axios';
import qs from 'qs';
import setAxiosConfig from './setAxiosConfig';
import {getCookie} from './cookie';

_axios.defaults.withCredentials = true
var axios = setAxiosConfig(_axios)

export const apiUrl = process.env.NODE_ENV === 'production' ? '' : '';
export const uploadUrl = 'http://cloud.coolgua.com/upload'
// export const uploadUrl = 'https://cloud.coolgua.net/upload'

// const apiUrl = '';

function formatUrl (data) {
  var str = '?';
  Object.keys(data).forEach((v) => {
    str += `${v}=${data[v]}&`
  });
  return str.substring(0, str.length - 1);
}

const getData = function (url, data = {}, resolve, reject) {
  url = apiUrl + url + formatUrl(data);
  return axios.get(url, {
    headers: getCookie('user') ? {
      'Authorization': JSON.parse(getCookie('user')).token
    } : {}
  }).then((res) => {
    resolve(res);
  }).catch((msg) => {
    reject(msg);
  });
};

var get = function (url, data = {}) {
  return new Promise((resolve, reject) => {
    getData(url, data, resolve, reject);
  })
}

const postData = function (url, data = {}, resolve, reject) {
  url = apiUrl + url;
  return axios.post(url, JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': getCookie('user') ? JSON.parse(getCookie('user')).token : ''
    }
  }).then((res) => {
    resolve(res);
  }).catch((msg) => {
    reject(msg);
  });
};

var post = function (url, data = {}) {
  return new Promise((resolve, reject) => {
    postData(url, data, resolve, reject);
  })
}

const postDataForm = function (url, data = {}, resolve, reject) {
  url = apiUrl + url;
  return axios.post(url, qs.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      'Authorization': JSON.parse(getCookie('user')).token
    }
  }).then((res) => {
    resolve(res);
  }).catch((msg) => {
    reject(msg);
  });
};

const putData = function (url, data = {}, resolve, reject) {
  url = apiUrl + url;
  return axios.put(url, JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': JSON.parse(getCookie('user')).token
    }
  }).then((res) => {
    resolve(res);
  }).catch((msg) => {
    reject(msg);
  });
};

var put = function (url, data = {}) {
  return new Promise((resolve, reject) => {
    putData(url, data, resolve, reject);
  })
}

var postForm = function (url, data = {}) {
  return new Promise((resolve, reject) => {
    postDataForm(url, data, resolve, reject);
  })
}

var postMultiForm = function (url, data = {}) {
  return new Promise((resolve, reject) => {
    postDataFormMulti(url, data, resolve, reject);
  })
}

const postDataFormMulti = function (url, data = {}, resolve, reject) {
  url = apiUrl + url;
  return axios.post(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': JSON.parse(getCookie('user')).token
    }
  }).then((res) => {
    resolve(res);
  }).catch((msg) => {
    reject(msg);
  });
};

export default {
  get,
  post,
  put,
  postForm,
  postMultiForm,
  apiUrl
}



// WEBPACK FOOTER //
// ./src/utils/ajax.js